import { createAction } from '@ngrx/store';

export const toggleBurgerPanel = createAction('[Panels] Toggle burger panel');
export const closeBurgerPanel = createAction('[Panels] Close burger panel');
